<template>
  <div class="switch_user">
    <div class="vx-row mt-5" v-if="user.roleId === roles.MULTILOCATION">
      <div class="vx-col w-full md:w-1/2 mb-base">
        <vx-card>
          <div class="vx-row flex-col-reverse md:flex-col-reverse sm:flex-row lg:flex-row">
            <!-- LEFT COL -->
            <div class="vx-col w-full md:w-full sm:w-1/2 lg:w-1/2 xl:w-1/2 flex flex-col justify-between">
              <div>
                <span class="font-medium">Login as selected user</span>

                <!-- Previous Data Comparison -->
                <div class="vx-row mt-5">
                  <div class="vx-col w-full mb-2">
                    <v-select v-model="selected" placeholder="Select User" :options="multiLevelUsers" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                  </div>
                </div>
                <div class="vx-row mb-6 mt-5">
                  <div class="vx-col w-full">
                    <vs-button @click="logIn">Log in</vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import vSelect from 'vue-select'
import { MULTILOCATION } from '@/utils/roles'

export default {
  name: 'SwitchUser',
  components: {
    vSelect
  },
  data: () => ({
    selected: null,
    roles: { MULTILOCATION }
  }),
  mounted() {
    if (this.user.roleId === MULTILOCATION) {
      this.submitAssign()
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('user', ['assignedUsers']),

    multiLevelUsers() {
      return this.assignedUsers.map(user => ({
        label: user.multiLocationUser.username,
        value: user.multiLocationUser.id
      }))
    }
  },

  methods: {
    async submitAssign() {
      try {
        await this.$store.dispatch('user/getAssignedUsers', { id: parseInt(this.user.id) })
        // eslint-disable-next-line no-empty
      } catch (err) {}
    },

    async logIn() {
      try {
        const { accessToken } = await this.$store.dispatch('auth/signInAs', parseInt(this.selected.value))
        localStorage.setItem('accessToken', accessToken)
        this.$router.go()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  }
}
</script>

<style></style>
